import { useEffect, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { QuickBooksProcessMode } from 'api/quickBooks';
import { useQuickBooksDetails } from 'assets/js/pages/account-settings/account-integrations/QuickBooks/useQuickBooksDetails';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { accountQueryKeys } from 'queries/account-query-keys';
import { transactionQueryKeys } from 'queries/transaction-query-keys';

const useQuickBooksSyncRefresh = () => {
    const { accountId } = useCurrentAccount();
    const { data: details } = useQuickBooksDetails({
        refetchInterval: ({ state }) => {
            return state.data?.process_mode !== QuickBooksProcessMode.Idle ? 2000 : 20000;
        },
    });

    const queryClient = useQueryClient();
    const [prevStatus, setPrevStatus] = useState<QuickBooksProcessMode>(details.process_mode);

    useEffect(() => {
        if (
            prevStatus !== QuickBooksProcessMode.Idle &&
            details.process_mode === QuickBooksProcessMode.Idle
        ) {
            queryClient.invalidateQueries({
                queryKey: transactionQueryKeys.transactions(accountId),
            });
            queryClient.invalidateQueries({
                queryKey: accountQueryKeys.quickBooksRules(accountId),
            });
        }

        setPrevStatus(details.process_mode);
    }, [details.process_mode, prevStatus, accountId, queryClient]);
};

export { useQuickBooksSyncRefresh };
